import type { BentoGridProps } from '@tyro/core';
import type { Widget } from '../@types/widget';

export function mapWidgetsToBentoGridLayouts(
  widgets: Widget[],
): BentoGridProps['layouts'] {
  const layouts: BentoGridProps['layouts'] = {
    lg: [],
  };
  for (const widget of widgets) {
    for (const [breakpoint, layout] of Object.entries(widget.layout)) {
      if (!Array.isArray(layouts?.[breakpoint as keyof typeof layouts])) {
        layouts[breakpoint as keyof typeof layouts] = [];
      }

      if (layout) {
        layouts[breakpoint as keyof typeof layouts].push({
          ...layout,
          i: widget.id,
        });
      }
    }
  }

  return layouts;
}
